import React from 'react';
export function StickyCTA() {
  const handleCTAClick = () => {
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    // Redirect to Shopify checkout
    window.location.href = 'https://www.tubienestarinterno.com/cart/53346355937617:1';
  };
  return <div className="fixed bottom-0 left-0 w-full p-4 z-50 md:hidden bg-gradient-to-t from-white via-white to-transparent pb-6 pt-8" data-id="element-275">
      <button onClick={handleCTAClick} className="w-full bg-brand-teal text-white font-semibold py-3 px-6 rounded-[20px] shadow-xl text-sm border-2 border-white" data-id="element-276">
        SÍ, QUIERO PASEOS EN PAZ ($9.95 USD)
      </button>
    </div>;
}